<template>
  <section class="hero"></section>
</template>

<script>
export default {
  name: "Hero"
};
</script>

<style scoped>
@keyframes animatedBackground {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: -9000px 0;
  }
}

.hero {
  height: 100vh;
  width: 100%;
  max-height: 800px;
  background-size: contain;
  background-position: 0px 0px;
  background: url(/images/hero.png);
  -webkit-animation: animatedBackground 90s linear infinite;
}
</style>
